type Props = {
  isLoggedIn: boolean;
};

const UserControls: FC<Props> = ({ isLoggedIn, children }) => {
  if (!isLoggedIn) {
    return null;
  }
  return children;
};

export default UserControls;
